import {createInstallFunction} from './install';
import I18nPlugin from './index';

export function createI18nPlugin(options) {
    I18nPlugin.install = createInstallFunction(options);
    const I18nService = new I18nPlugin(options);

    return {
        I18nService,
        I18nPlugin,
    };
}
